<div class="title">
  <span class="title estricta uppercase"> Pagamento de contemplação </span>
</div>


<app-card class="density-lower">

  <form [formGroup]="form" class="density-mat-form-3" (keydown.enter)="$event.preventDefault(); filter()">
    <span class="estricta uppercase"> Filtros </span>
    <br />
    <br />

    <div class="filters">
        <div class="group1">


          <span class="form-field">
            <label> Ponto de Venda: </label>
            <mat-form-field appearance="outline" class="density-mat-form-3">
              <mat-select formControlName="identifierCode" data-cy="dealer" placeholder="Selecione">
                <mat-option *ngFor="let dealerOption of dealerOptions" [value]="dealerOption.value"> {{dealerOption.key}}
                </mat-option>
              </mat-select>

              <mat-error *ngIf="form.get('identifierCode').hasError('required') && form.get('identifierCode').touched" data-cy="dealerRequiredError">
                <strong> Campo obrigatório </strong>
              </mat-error>
            </mat-form-field>
          </span>

        </div>

    </div>


    <div class="filters">


      <div class="group1">
        <app-custom-datapicker label="Data Inicial:" formControlName="startDate" [control]="form.get('startDate')"
          datacy="startSalesDate">
          <mat-error *ngIf="form.hasError('startGreaterThanEnd')" class="fix-error-position" data-cy="startSalesDateErrorStartGreaterThanEnd">
            <strong> Data Inicial não pode ser maior que data final </strong>
          </mat-error>
          <mat-error *ngIf="form.hasError('startDate-required') && (form.get('endDate').touched || form.get('startDate').touched)" class="fix-error-position" data-cy="startSalesDateErrorRequired">
            <strong> Data inicial deve ser prenchida </strong>
          </mat-error>
          <mat-error *ngIf="form.hasError('periodGreaterThan')" class="fix-error-position" data-cy="startSalesDateErrorPeriodGreaterThan30Days">
            <strong> Não é possível efetuar pesquisa com mais de 30 dias  </strong>
          </mat-error>
        </app-custom-datapicker>


      </div>

      <div class="group1">

        <app-custom-datapicker label="Data Final:" formControlName="endDate" [control]="form.get('endDate')"
          datacy="endSalesDate">
          <mat-error *ngIf="form.hasError('endDate-required') && (form.get('endDate').touched || form.get('startDate').touched)" class="fix-error-position" data-cy="endSalesDateErrorRequired">
            <strong> Data final deve ser prenchida </strong>
          </mat-error>
        </app-custom-datapicker>


      </div>
    </div>

    <div class="button-filters">
      <app-button type="submit" width="100%" datacy="button-clean" (onClick)="cleanForm()" datacy="button-clear" [disabled]="!hasAccessToAnyDealer">
        <span style="font-size: 16px;"> Limpar </span>
      </app-button>

      <app-button type="submit" width="100%" color="primary" [disabled]="!form.valid || loading || !hasPermissionToRead || !hasAccessToAnyDealer" [loading]="loading"
        (onClick)="filter()" datacy="button-search">
        <span style="font-size: 16px;"> Pesquisar </span>
      </app-button>
    </div>
  </form>

</app-card>

<div class="export-actions">
  <app-button *ngIf="hasPermissionToExportPdf" [disabled]="isExportingPdf || !hasAccessToAnyDealer" [loading]="isExportingPdf" (click)="exportPdfReport()" datacy="button-export-pdf">
    <span>
      Exportar PDF
    </span>
  </app-button>

  <app-button *ngIf="hasPermissionToExportExcel" [disabled]="isExportingExcel || !hasAccessToAnyDealer" [loading]="isExportingExcel" (click)="exportWorksheetReport()" datacy="button-export-xlxs">
    <span>
      Exportar Excel
    </span>
  </app-button>
</div>

<div class="table">
  <app-table [table]="table" (emitPaginatorChanged)="pageChange($event)">
  </app-table>
</div>
